(function (window) {
  /**
   * Turns a textarea with Excel-like data into an HTML table
   * @param {HTMLElement} textareaElement The textarea to turn into a HTML table
   * @constructor
   */
  var BatchGeoTableize = function (textareaElement) {
    // Parse the CSV data in the textarea and get back an array that we can work
    // with to create the table
    var rows = BatchGeo.parseCsv(textareaElement.value, { delimiter: "\t" });

    // Create some wrapper elements to be used elsewhere
    var $wrapper = $("<div />", { class: "tableize tableize-wrapper" });
    var $table = $("<table />", { class: "tableize tableize-table" });

    if (textareaElement.$table) {
      textareaElement.$table.remove();
    }

    textareaElement.$table = $wrapper;

    if (rows.length) {
      // BatchGeo supports "commented out" rows in the spreadsheet. If the first
      // character in a row starts with # like `# Hello World` we will skip that
      // line and every line like that until we find a line that doesn't stars
      // with a hash. We skip by finding the first row that doesn't start with a #
      var start = 0;
      while (
        start < rows.length &&
        (rows[start].length <= 0 || rows[start][0].substring(0, 1) === "#")
      ) {
        start++;
      }
      if (rows.length <= start) {
        return;
      }
      // If there is only 1 row we create a header for the user since they most
      // likely didn't just submit a table header
      if (rows.length - start === 1) {
        // Since we're manually creating this row we need to add empty cells for
        // however many columns there is minus the first one which we will fill
        // out with "Location". Luckily, lodash has a function just for this:
        var fillerCells = _.fill(Array(rows[0].length - 1), "");

        // Take our Location cell for the first column + filler cells and merge
        // and then we add that row to the top (index 0) with unshift
        rows.unshift(_.concat("Location", fillerCells));
      }

      // Create a header row and insert it into the table before we add any other
      // rows to the table
      var $headerRow = $("<tr />");
      rows[start].forEach(function (row) {
        $("<th />", { html: row }).appendTo($headerRow);
      });
      $table.append($headerRow);

      // _.take() will "take" only up to N items from an array and any number
      // below so _.take(array, 5) would return the first 5 items if the array had
      // >5 items and it would return 2 items if the array had 2. _.drop() will
      // remove N items from the array from the start. For _.drop here we use the
      // start position then add one because we have our header row. This should
      // start us at the first row of actual data. Then, for each of those rows
      // we create a table row, it's data (<td>s) then append to the table.
      _.take(_.drop(rows, start + 1), 50).forEach(function (row) {
        $table.append(
          $("<tr />").append(
            row.map(function (cell) {
              return $("<td />", {
                html: cell.length ? cell : " ",
              });
            }),
          ),
        );
      });

      $($wrapper).toggleClass(
        "tableize-example",
        rows[0][0] === "Example Address",
      );
    }

    // Once the table is all done add this to our wrapper
    $wrapper.append($table);
    $wrapper[0].el = textareaElement;

    // This creates the overlay helper text over the table when you hover or or
    // start dragging over the page
    var $em = $("<em />", {
      class: "tableize tableize-overlay",
      html: textareaElement.title || "click to copy/paste",
    });
    $wrapper.append($em);
    $em[0].tbl = $table;

    // We hide the textarea by default because it only shows when you click on
    // the table we generated and once it's hidden we add our new table wrapper.
    $(textareaElement).hide().before($wrapper);

    // special case scenario for home page for faster loading
    $("#deleteMe").remove();

    if (BatchGeo.msie) {
      $table.css("filter", "");
      $em.css("filter", "");
    }

    $($wrapper).on("click contextmenu focus", function (event) {
      textareaElement = event.currentTarget.el;
      textareaElement.tbl = null;
      $(textareaElement).show();
      textareaElement.select();
      $(this).remove();
    });

    $($wrapper).on("scroll", function () {
      $($em).css("top", $(this).scrollTop());
    });

    $("input,textarea").on("click", function () {
      BatchGeoStore.dispatch({ type: "GENERATOR_FOCUSED_ELSEWHERE" });
    });

    // In Chrome, Safari, and Firefox this will work even when textarea
    // isn't selected. IE falls back on code below.
    $(document).on("paste", function (e) {
      try {
        var val = e.originalEvent.clipboardData.getData("Text");

        // If it was focused on something else we want to return early
        // so that the paste will work for other inputs
        if (BatchGeoStore.getState().Generator.focusedElsewhere) {
          return true;
        }

        BatchGeoStore.dispatch({ type: "GENERATOR_DATA_CHANGED" });

        if (textareaElement.value != val) {
          textareaElement.value = val;
          BatchGeoTableize(textareaElement);
          window.unValidateSource();
          return false;
        }
      } catch (err) {
        BatchGeoStore.dispatch({ type: "GENERATOR_DATA_RESET" });
        console.log("clipboard access failed");
      }

      return true;
    });

    textareaElement.charCount = textareaElement.value.length;

    if (
      typeof document.getElementById("sourceData").addEventListener ==
      "undefined"
    ) {
      $(textareaElement).off("keyup mouseup");
      $(textareaElement).on("keyup mouseup", function (event) {
        if (Math.abs(event.target.charCount - event.target.value.length) > 10) {
          BatchGeoTableize(event.target);
          window.unValidateSource();
        }
        event.target.charCount = event.target.value.length;
      });
    }

    $(textareaElement).off("blur");
    // blurs should only happening when manipulating manually, so set ... input box
    $(textareaElement).on("blur", function (e) {
      //check geocount any time the textarea blur event is fired (on change listener is not sufficient)
      var rows = BatchGeo.parseCsv(e.target.value, { delimiter: "\t" });

      //check cache break
      const breakcache = Boolean($("#breakcache_cb")[0]?.checked);

      if (
        !window.checkGeocodesRemainingEngaged ||
        (window.checkGeocodesRemainingEngaged && breakcache)
      ) {
        if (BatchGeoStore.getState().App.isEdit && !breakcache) {
          BatchGeoTableize(e.target);
          return;
        }
        window.checkGeocodesRemainingEngaged = true;

        const rowCount = rows.filter((row) => row[0].length > 0).length - 1;
        if (rowCount > 0) {
          window.checkGeocodesRemaining(rowCount);
        }
      }
      BatchGeoTableize(e.target);
    });
  };

  window.BatchGeoTableize = BatchGeoTableize;
})(window);
